<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary font-weight-bold">Paiements ({{ paiements.length }})</h4>
            </div>
            <div class="mr-4">
                <NavOperations></NavOperations>
            </div>
        </template>
        <template #content>
            <div class="container">
                <form class="form-inline mb-4" @submit.prevent="changePeriod()">
                    <input class="form-control form-control-sm" type="month" id="start" name="start" min="2018-03"
                        v-model="form.period" />
                    <button type="submit" class="ml-2 btn btn-sm btn-primary">
                        <i class="fa-solid fa-magnifying-glass"></i> Charger 
                    </button>
                </form>
                <ProgressBar v-if="isLoading === true" mode="indeterminate" style="height: 6px; margin-bottom: 10px;"></ProgressBar>
                <p v-if="isEmpty == true" class="text-center"> Vous n'avez pas effectué de paiement ce mois</p>
                <div class="card mb-3 shadow-2 " v-for="paiement in paiements" :key="paiement.id"
                    @click="openShowModal(paiement)">
                    <div class=" card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <p class="text-secondary">Date</p>
                                <strong>{{ formatDate(paiement.date_operation) }}</strong>
                            </div>
                            <div class="col-md-4 text-center">
                                <p class="text-secondary">Course</p>
                                <strong>{{ paiement.course_details }}</strong>
                            </div>
                            <div class="col-md-3">
                                <p class="text-secondary">Libellé</p>
                                <strong>{{ paiement.libelle }}</strong>
                            </div>
                            <div class="col-md-1">
                                <p class="text-secondary">Mode</p>
                                <strong>{{ paiement.mode }}</strong>
                            </div>
                            <div class="col-md-2">
                                <p class="text-secondary">Montant</p>
                                <strong>{{ formatPriceWithDevise(paiement.montant) }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </yams-template>
</template>
  
<script >
import moment from 'moment'
import NavOperations from '../NavOperations.vue';
import { defineComponent, defineAsyncComponent } from 'vue';
const ShowPaiement = defineAsyncComponent(() => import('./ShowPaiement.vue'));
// const CreatePaiement = defineAsyncComponent(() => import('./CreatePaiement.vue'));

export default defineComponent({
    name: 'IndexPaiement',
    components: { NavOperations },
    data() {
        return {
            isLoading: false,
            url: '/api/paiements',
            isEmpty: false,
            paiements: [],
            paiementsUrl: this.$store.state.api_yams_livraisons + '/api/paiements?req_period=' + moment().format('YYYY-MM'),
            baseUrl: this.$store.state.api_yams_livraisons,
            form: {
                period: moment().format('YYYY-MM'),
            },
        };
    },
    mounted() {
        this.getPaiements()
    },
    methods: {
        formatDate(val) {
            if (val) return moment(String(val)).format('DD/MM/YYYY')
        },
        formatPriceWithDevise(val) {
            if (val) return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'XAF' }).format(val)
        },
        changePeriod() {
            this.isEmpty = false
            this.paiementsUrl = this.baseUrl + this.url + '?req_period=' + this.form.period
            this.getPaiements()
        },
        getPaiements() {
            this.isLoading = true
            this.axios.get(this.paiementsUrl).then((response) => {
                this.paiements = response.data.data
                if (response.data.data.length < 1) {
                    this.isEmpty = true
                }
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        openShowModal(objData) {
            this.$dialog.open(ShowPaiement, {
                props: {
                    header: "Paiement N°"+objData.id,
                    style: {
                        width: '40vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        // openCreateModal() {
        //     this.$dialog.open(CreatePaiement, {
        //         props: {
        //             header: "Nouveau paiement",
        //             style: {
        //                 width: '50vw'
        //             },
        //             modal: true
        //         },
        //         data: this.course_id
        //     });
        // },
    },
});
</script>
    
<style scoped>
.card {
  cursor: pointer;
}
</style>